export default {
  sizeSmall: {
    fontSize: "11px",
    fontWeight: 600,
    padding: "2px 0px 2px 0px",

    margin: 0,
    height: "20px"
  }
};
